/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createSlice } from '@reduxjs/toolkit';
import { Customer, CustomerAddress, CustomerAttributes, CustomerAttributeUpdate } from '@models';

interface CustomerState {
  selectedCustomer?: Customer;
  customersAttributes?: CustomerAttributes[];
  customersAttributeUpdate?: CustomerAttributeUpdate[];
  verified?: boolean;
}

export const customerSlice = createSlice({
  name: 'customer',
  initialState: {
    value: {
      selectedCustomer: JSON.parse(localStorage.getItem('selectedCustomer')!),
      customersAttributes: JSON.parse(localStorage.getItem('customersAttributes')!),
      verified: false,
    } as CustomerState,
  },
  reducers: {
    setSelectedCustomer: (state, action: { type: string; payload: Customer }) => {
      state.value.selectedCustomer = action.payload;
      state.value.verified = false;
      localStorage.setItem('selectedCustomer', JSON.stringify(action.payload));
    },
    setCustomerAttributes: (state, action: { type: string; payload: CustomerAttributes[] }) => {
      state.value.customersAttributes = action.payload;
      localStorage.setItem('customersAttributes', JSON.stringify(action.payload));
    },
    setCustomerAttributesUpdate: (state, action: { type: string; payload: CustomerAttributeUpdate[] }) => {
      state.value.customersAttributeUpdate = action.payload;
    },
    upsertSelectedCustomerAddress: ({ value: { selectedCustomer } }, action: { type: string; payload: CustomerAddress }) => {
      if (!selectedCustomer) return;

      const existingIndex = selectedCustomer.addresses.findIndex((address) => address.id === action.payload.id);

      //increase the number of addresses stored
      if (selectedCustomer.address_count || selectedCustomer.address_count === 0) {
        selectedCustomer.address_count = selectedCustomer?.address_count + 1;
      }

      if (existingIndex >= 0) {
        selectedCustomer.addresses[existingIndex] = action.payload;
      } else {
        selectedCustomer?.addresses.push(action.payload);
      }
    },
    deleteSelectedCustomerAddress: ({ value: { selectedCustomer } }, action: { type: string; payload: number }) => {
      if (!selectedCustomer) return;

      const index = selectedCustomer.addresses.findIndex((address) => address.id === action.payload);

      if (index >= 0) {
        selectedCustomer.addresses.splice(index, 1);

        //reduce address count of customer
        if (selectedCustomer.address_count) {
          selectedCustomer.address_count = selectedCustomer?.address_count - 1;
        }
      }
    },
    setCustomerInitialState: (state) => {
      state.value = {};
    },
    setCustomerVerification: (state, action: { type: string; payload: boolean }) => {
      state.value.verified = action.payload;
    },
  },
});

export const {
  deleteSelectedCustomerAddress,
  setSelectedCustomer,
  upsertSelectedCustomerAddress,
  setCustomerAttributes,
  setCustomerAttributesUpdate,
  setCustomerInitialState,
  setCustomerVerification,
} = customerSlice.actions;

export default customerSlice.reducer;
